import { getVehiclePhosphorIcon } from '@/utils/phosphorIcons';
import { cn } from '@/lib/utils';

interface VehicleTypeIconProps {
  type: string;
  className?: string;
  size?: number;
  weight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
}

export const VehicleTypeIcon = ({ 
  type, 
  className, 
  size = 16,
  weight = 'duotone' 
}: VehicleTypeIconProps) => {
  const Icon = getVehiclePhosphorIcon(type);
  return <Icon className={cn('', className)} size={size} weight={weight} />;
};
